import type {
  AnalyticsCartItemSource,
  ModifyCartItemByDecoratedProduct
} from '~/stores/cartStore/model';
import { isDefined } from '~/utils/guards/isDefined';

/** Picks the analytics-relevant fields from a decorated cart or order line item. */
export function pickAnalyticsCartItemFields(
  item: AnalyticsCartItemSource
): AnalyticsCartItemSource {
  return {
    quantity: item.quantity,
    decoratedProduct: item.decoratedProduct,
    breadcrumbs: item.breadcrumbs
  };
}

/**
 * Maps cart line items to the analytics payload shape, including pre-resolved
 * breadcrumbs when available so `createEcommerceTrackingData` skips slugById.
 */
export function mapCartItemsForAnalytics(
  items: ReadonlyArray<AnalyticsCartItemSource | undefined>
): ModifyCartItemByDecoratedProduct[] {
  return items.filter(isDefined).flatMap((item) => {
    if (!isDefined(item.decoratedProduct) || !isDefined(item.quantity)) {
      return [];
    }

    return [
      {
        quantity: item.quantity,
        decoratedProduct: item.decoratedProduct,
        breadcrumbs: item.breadcrumbs
      }
    ];
  });
}
